module.exports = __webpack_public_path__ + "img/p62-yearbooks-collection.5599d03c.jpg";